import { List, Typography } from "@mui/material";

import LoadingIndicator from "../../Common/LoadingIndicator/LoadingIndicator";

import EntityLocationsListItem from "./EntityLocationsListItem";
import EntityLocationsTableHeader from "./EntityLocationsTableHeader";

export default function EntityLocationsTable({ data, isLoading }) {
  if (isLoading) {
    return <LoadingIndicator />;
  }

  if (!data || data.length === 0) {
    return <Typography className="text-center">No locations</Typography>;
  }

  return (
    <div className="absolute bottom-0 top-0 flex w-full flex-col overflow-y-auto px-2 [&::-webkit-scrollbar-thumb]:bg-blue-700 [&::-webkit-scrollbar]:[width:6px]">
      <EntityLocationsTableHeader />
      <List className="flex h-full flex-col gap-4" disablePadding>
        {data.map((location) => (
          <EntityLocationsListItem key={location.id} data={location} />
        ))}
      </List>
    </div>
  );
}
